import { PureComponent, ReactNode } from 'react'
import { DispatchProp } from 'react-redux'
import { connectRedux } from '../../../helpers/connectRedux'
import { IServiceInfo } from '../../../models'
import { IStoreState } from '../../../store/states'
import MapSlot from '../../MapSlot'
import { setIsAlterationsModalOpenAction } from '../../../store/actions'
import { images } from '../../../images'
import StyledDiv from './styles'
import { RouteComponentProps, withRouter } from '../../../helpers/withRouter'
import { AnyAction } from 'redux'

interface IProps extends DispatchProp<AnyAction>, RouteComponentProps {
  serviceInfos: IServiceInfo[]
}

class MapStopsView extends PureComponent<IProps> {
  public render(): ReactNode {
    const { serviceInfos } = this.props

    if (!serviceInfos || !serviceInfos.length) return null

    const hasAlterations = serviceInfos.some((serviceInfo) => serviceInfo.alterationMessages.length > 0)

    return (
      <StyledDiv>
        <MapSlot />
        {
          hasAlterations &&
          <div className='alterations-icon' onClick={ this.handleAlterationsClick }>
            <img src={images.alteration} alt='alterations-icon' />
          </div>
        }
      </StyledDiv>
    )
  }

  private handleAlterationsClick = () => {
    this.props.dispatch(setIsAlterationsModalOpenAction(true))
  }
}

const mapStateToProps = ({ newReservation }: IStoreState) => ({
  serviceInfos: newReservation.serviceInfos
})

export default withRouter(connectRedux(mapStateToProps, MapStopsView as any))
